import { createFromJS } from "../../types";

const getMindmapsById = state => state.getIn(["data", "mindmaps", "byId"]);

const getMindmapsCount = state => getMindmapsById(state).size;

const getMindmapList = state =>
  getMindmapsById(state)
    .map(mindmap => createFromJS.MindmapListItem(mindmap, "id", "label"))
    .toList();

const getMindmap = (state, id) => getMindmapsById(state).get(id);

const getMindmapNodes = (state, id) => getMindmap(state, id).getIn(["nodes", "byId"]);

const getMindmapHiddenReferenceTypes = (state, id) => getMindmap(state, id).hiddenReferenceTypes;

export default {
  getMindmapNodes,
  getMindmapsById,
  getMindmapsCount,
  getMindmapList,
  getMindmap,
  getMindmapHiddenReferenceTypes
};
